import React from "react";
import { useParams } from "react-router";
import NavBar from "../components/NavBarOthers";

const ArticlePage = (props) => {
  const articles = [
    {
      id: 1,
      title:
        "Wilson Bright on building the BlockSurvey book of digital privacy and ownership of ideas, identity and data",
      description:
        "One of YourStory’s Tech50 2021 startups, here’s how BlockSurvey is working as an alternative to free platforms in the underserved space of forms and surveys to build a more holistic, safe and secure digital identity anchored by encryption keys.",
      img: "https://images.yourstory.com/cs/2/0e302530227f11ec9e19b7c38d296967/BlockSurvey2Wilson-1638513335483.png?fm=auto&ar=2:1&mode=crop&crop=faces&w=720",
      article: "",
    },
    {
      id: 2,
      title:
        "Crypto.com to Create First-of-Its-Kind NFT Collection Generated by the Speed and Sound of the Formula 1 Crypto.com Miami Grand Prix",
      description:
        "Crypto.com, the world’s fastest growing cryptocurrency platform, will create a collection of NFTs generated in real-time by the speed, sound and data of the Formula 1 Crypto.com Miami Grand Prix. In a world first, the NFTs will be one-of-a-kind visual expressions capturing the kinetic energy released by each of the 57 race laps.",
      img: "https://content-hub-static.crypto.com/static/1d2cae47358a2dc22b8669d7fd92f486/d7166/CDC-Kinetica-Title_1200x728.png",
      article: "",
    },
    {
      id: 3,
      title:
        "Meet the engineers building a simple mobile wallet for using blockchain-based apps",
      description:
        "Abhimanyu Shekhawat and Akshit Ostwal started developing Orange Wallet in December 2020 to provide a simple, mobile experience for users to access blockchain-based Decentralised Finance (DeFi) apps. With an initial grant from Indian blockchain startup Polygon, the duo set to work.",
      img: "https://images.yourstory.com/cs/2/98e25df018b511e988ceff9061f4e5e7/OrangeWallet800x400-1630423976792.png?fm=auto&ar=2:1&mode=crop&crop=faces&w=720",
      article: "",
    },
    {
      id: 4,
      title:
        "UniFarm launches 3 back-to-back IDOs, listing on 3 top centralized exchanges & much more",
      description:
        "Leading group farming staking protocol- ‘UniFarm’ which announced its IDO Launchpad- ‘UNIFARM Launch’ earlier last month is all set to announce 3 new back-to-back IDOs for its rapidly growing community. Post the launch of UniFarm Cohort 36 with 4 top-tier projects, including SpaceSwap ($MILK2), BattleVerse ($BVC), NFT4Play ($4PLAY), and UniFarm ($UFARM) UniFarm is elated to announce IDO Launch for GameYoo, DCD Ecosystem and Wizardium through its IDO launchpad.",
      img: "https://www.dqindia.com/wp-content/uploads/2021/09/Blockchain-in-healthcare1.jpg",
      article: "",
    },
  ];

  let { id } = useParams();
  console.log(id);

  const article = articles.filter((e) => e.id == id);
  console.log(article);

  return (
    <div>
      <NavBar />
      <div className="my-24 lg:mx-16 mx-4 flex lg:flex-row flex-col">
        <img
          className="lg:mx-4 mx-0 md:w-1/2 w-full rounded-xl"
          alt="img"
          src={article[0].img}
        />
        <div className="flex flex-col justify-around lg:mt-0 mt-8">
          <h1 className="lg:text-4xl text-3xl font-bold lg:px-4 px-0">
            {article[0].title}
          </h1>
          <p className="text-xl font-medium lg:px-4 px-0 lg:mt-0 mt-8">
            {article[0].description}
          </p>
        </div>
      </div>
      <div className="article_main">{article.article}</div>
    </div>
  );
};

export default ArticlePage;
